module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAXBAMAAADjD5IeAAAAMFBMVEUAAADwhy34jzX1jDL0jzHzjTD1jDL0jTH0jTHzjjD1jTL0jDH0jTHzjTD0jTH0jTEz6o+bAAAAD3RSTlMAESIzRFVmd4iZqrvM3e5GKvWZAAAAqklEQVQYGQXBiy2DAQCAwUs94lURE8i/ABuwARsYwQjtBmygI9igRrBB2wlE4lnRz53TYRjgdBgGx9UU8/q0Wy3Zrp6Y1w9HtTnhvDYnbusDe9WDRc1gUW+7tQHXtR7XB9ivJjUDXqv+ALdV74CDqhngsGoFuKtaA6PXqm7AYf0uagkm9X5XPzCqZuPqCkfV2U71gvtaM69vtqoVl9WFcTXloHr2WBuMqq9/cpSQt2yIviMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/x@2x.png
// module id = Up05
// module chunks = 18